import { ParsedIdToken } from '@quirion/types';

export function parseIdToken(
  token: string | undefined,
): ParsedIdToken | undefined {
  const split = token?.split('.');
  return split
    ? [JSON.parse(atob(split[0])), JSON.parse(atob(split[1])), split[2]]
    : undefined;
}
